
import { Component, Vue } from 'vue-property-decorator';
import echarts from 'echarts/lib/echarts'; // 引入基本模板
// import map from 'echarts/lib/chart/map';
import LogUtils from 'panda-log';
import 'echarts/map/js/china';
import ShortcutDate from '@/components/shortcutdate/shortcutdate.vue';
import { iSelectOptionsList } from '@/interface/cancel-detail';
import { getDelayTtl } from '@/api/statistics';
//将echarts绑定到vue的原型上
// Vue.prototype.$echarts = echarts;
@Component({
  components: { ShortcutDate },
})
export default class extends Vue {
  chart = null;
  private dataDefault: Date = new Date();
  private start!: any;
  private end!: any;
  public dates: (string | Date)[] = [];
  heightChart: string = '';
  private pickerBeginDateBefore: { disabledDate: Function } = {
    disabledDate(time: any) {
      return time.getTime() > Date.now();
    },
  };
  //快捷日期:
  private shortcutDays: iSelectOptionsList[] = [
    { label: '昨日', value: 1 },
    { label: '近7天', value: 7 },
    { label: '近15天', value: 15 },
    { label: '近30天', value: 30 },
  ];
  private initDay: string | number = 1;
  defaultDays: { day: number; initDay: number } = { day: 7, initDay: 1 }; // 默认近7天

  official_node: any[] = [
    /* { name: '成都', value: [104.06, 30.67] },
    { name: '拉萨', value: [89.06, 30.67] }, */
  ];
  delayTims: any[] = [];
  get opts() {
    return {
      tooltip: {},
      visualMap: {
        type: 'piecewise',
        left: '0',
        bottom: 80,
        text: ['延迟高', '延迟低'],
        seriesIndex: [1],
        inRange: {
          color: ['#008B45', '#43CD80', '#54FF9F', '#C1FFC1'],
        },
        realtime: false,
        pieces: [
          { gt: 30, label: '>30ms' },
          { gt: 20, lte: 30, label: '20-30ms' },
          { gt: 10, lte: 20, label: '10-20ms' },
          { gt: 0, lt: 10, label: '0-10ms' },
        ],
        showLabel: true,
        calculable: true,
      },
      geo: {
        type: 'map',
        map: 'china',
        roam: true,
        zoom: 1.2,
        scaleLimit: {
          min: 1,
          max: 3,
        },
        label: {
          normal: {
            show: true,
            textStyle: {
              color: 'rgba(0,0,0,0.4)',
            },
          },
        },
        itemStyle: {
          normal: {
            borderColor: 'rgba(0, 0, 0, 0.2)',
          },
          emphasis: {
            areaColor: null,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowBlur: 20,
            borderWidth: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
      series: [
        {
          type: 'scatter',
          coordinateSystem: 'geo',
          data: this.official_node,
          symbolSize: 36,
          symbol: 'pin',
          symbolRotate: 0,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(50,50,50,0.7)',
            formatter: function(params: any) {
              return params.data.data;
            },
          },
          label: {
            normal: {
              color: '#fff',
              fontSize: 8,
              align: 'center',
              formatter: '{b}',
              position: 'inside',
              show: true,
            },
            emphasis: {
              show: true,
            },
          },
          itemStyle: {
            normal: {
              color: '#53868B',
            },
          },
        },
        {
          name: '延迟',
          type: 'map',
          geoIndex: 0,
          tooltip: {
            show: true,
            backgroundColor: 'rgba(50,50,50,0.7)',
            formatter: function(params: any) {
              return params.seriesName + '<br/>' + params.name + ':' + (params.value ? params.value + 'ms' : '--');
            },
          },
          data: this.delayTims,
        },
      ],
    };
  }

  getShortcutTimeFn(dates: (string | Date)[], params: { start: number; end: number }, activeIndex: number) {
    this.initDay = activeIndex;
    this.dates = dates;
    this.start = params.start;
    this.end = params.end;
    this.getDelayInfo();
  }
  dateHandler(datavalue: Date[]) {
    this.initDay = '';
    this.start = Math.floor(datavalue[0].getTime() / 1000);
    this.end = Math.floor(datavalue[1].getTime() / 1000) + 3600 * 24 - 1;
    this.getDelayInfo();
  }

  setEchart() {
    let self: any = this;
    self.chart = echarts.init(this.$refs.mapChart as HTMLDivElement);
    self.chart.setOption(self.opts, true);
  }
  async getDelayInfo() {
    try {
      const res = await getDelayTtl({ start: this.start, end: this.end });
      if (res && res.code == 0) {
        this.official_node = [];
        for (const nodeItem of res.data.official_node) {
          this.official_node.push({ name: nodeItem.name, value: nodeItem.gps, data: nodeItem.nodes });
        }
        this.delayTims = res.data.ttl;
        this.setEchart();
      }
    } catch (err) {
      //
    }
  }
  mounted() {
    this.heightChart = document.body.clientHeight - 120 + 'px';
    let self: any = this;
    window.onresize = function() {
      self.chart.resize();
    };
    this.getDelayInfo();
  }
}
